<script lang="ts">
    import type DataProvider from "../services/data.provider";
    import type ServiceProvider from "../services/service.provider";
    import WhispererList from "./WhispererList.svelte";
    import { clickOutside } from "../../../core/directives/click-outside.directive";
    import { TemplateType } from "../interfaces/search.interface";

    export let dataProvider: DataProvider;
    export let serviceProvider: ServiceProvider;

    let whispererList: WhispererList | any;
    let searchString: string = null
    let displayWhisperer = false

    $: isListDisplayed = !!(searchString && displayWhisperer)

    const onKeyUp = (e: any): void => {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        dataProvider.searchString = e.target.value || null;
        // eslint-disable-next-line @typescript-eslint/no-unsafe-call
        whispererList.onKeyUpProvider(e);
    };
    const onFocus = (e: any): void => {
        if (e.target.value) {
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
            dataProvider.searchString = e.target.value;
            // eslint-disable-next-line no-undef
            setTimeout(() => {
                serviceProvider.whispererSearchService.searchWhispererSubs = true;
            }, 200);
        }
    };
    const onSubmit = (): void => {
        serviceProvider.searchService.submitSearch();
        serviceProvider.whispererSearchService.searchWhispererSubs = false;
    };
    const handleClickOutside = (): void => {
        serviceProvider.whispererSearchService.searchWhispererSubs = false;
    }

    dataProvider.searchStringSubs.subscribe(
        (search: string | null) => (searchString = search)
    )
    serviceProvider.whispererSearchService.searchWhispererSubs.subscribe(
        (display: boolean) => (displayWhisperer = display)
    )
</script>

<div
    class="bno-search autocomplete-visible"
    class:bno-search--compact={dataProvider.template === TemplateType.FOOTER}
>
    <div class="bno-search__inner">
        <form
            aria-label="Hlavní vyhledávání"
            on:submit|preventDefault={onSubmit}
            use:clickOutside
            on:click_outside={handleClickOutside}
        >
            <div class="bno-form-control">
                <input
                    id="search-whisperer-{dataProvider.uniqueId}"
                    on:keyup={onKeyUp}
                    on:focus={onFocus}
                    value={dataProvider.isSubmitFromUrlAllowed ? dataProvider.searchParameterFromUrl : ''}
                    class="bno-form-control__input bno-form-control__input--standalone"
                    type="text"
                    autocomplete="off"
                    aria-required="false"
                    aria-disabled="false"
                    role="searchbox"
                    aria-autocomplete="list"
                    aria-controls="bno-autocomplete-list-{dataProvider.uniqueId}"
                    aria-expanded="{isListDisplayed}"
                    aria-multiline="false"
                    aria-label="Vyhledávání"
                    placeholder={dataProvider.placeholder}
                />
                {#if dataProvider.template !== TemplateType.HEADER}
                    <WhispererList
                        {dataProvider}
                        {serviceProvider}
                        bind:this={whispererList}
                    />
                {/if}
                <label
                    class="bno-form-control__label u-sr-only"
                    for="search-whisperer-{dataProvider.uniqueId}"
                >
                    {dataProvider.cta}
                </label>
            </div>
            {#if dataProvider.template === TemplateType.FOOTER}
                <button
                    class="bno-toggle bno-toggle--plain"
                    type="submit"
                    aria-label="Odeslat formulář vyhledávání"
                >
                    <span class="bno-icon bno-icon--search" />
                </button>
            {:else}
                <button
                    class="bno-button bno-button--secondary"
                    type="submit"
                    aria-label="Odeslat formulář vyhledávání"
                >
                    {dataProvider.cta}
                </button>
            {/if}
        </form>
    </div>
    {#if TemplateType.HEADER === dataProvider.template}
        <WhispererList
            {dataProvider}
            {serviceProvider}
            bind:this={whispererList}
        />
    {/if}
</div>
